import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class LinearSVCGraph extends AbstractScatterVisualization {
}
